 export enum TriListeSalariesEnum {
NumeroSalarieCroissant = 0,
NumeroSalarieDecroissant = 1,
NumeroContratCroissant = 2,
NumeroContratDecroissant = 3,
CiviliteCroissant = 4,
CiviliteDecroissant = 5,
NomPrenomCroissant = 6,
NomPrenomDecroissant = 7,
NomNaissanceCroissant = 8,
NomNaissanceDecroissant = 9,
QualificationCroissant = 10,
QualificationDecroissant = 11,
DateEntreeCroissant = 12,
DateEntreeDecroissant = 13,
DateDebutContratCroissant = 14,
DateDebutContratDecroissant = 15,
DateDepartCroissant = 16,
DateDepartDecroissant = 17,
DateFinContratCroissant = 18,
DateFinContratDecroissant = 19,
TypeContratCroissant = 20,
TypeContratDecroissant = 21,
RegimeCroissant = 22,
RegimeDecroissant = 23,
BulletinParMailCroissant = 24,
BulletinParMailDecroissant = 25,
NatureContratCroissant = 26,
NatureContratDecroissant = 27,
RemunerationCroissant = 28,
RemunerationDecroissant = 29,
CongesCroissant = 30,
CongesDecroissant = 31,
ConventionCollectiveCroissant = 32,
ConventionCollectiveDecroissant = 33,
TempsTravailCroissant = 34,
TempsTravailDecroissant = 35,
MutuelleCroissant = 36,
MutuelleDecroissant = 37,
ModeReglementCroissant = 38,
ModeReglementDecroissant = 39,
ResponsableHierarchiqueCroissant = 40,
ResponsableHierarchiqueDecroissant = 41,
NotaireResponsableCroissant = 42,
NotaireResponsableDecroissant = 43,
LibelleEmploiCroissant = 44,
LibelleEmploiDecroissant = 45,
DateFinPeriodeEssaiCroissant = 46,
DateFinPeriodeEssaiDecroissant = 47,
DateFinPrevisionnelleCddCroissant = 48,
DateFinPrevisionnelleCddDecroissant = 49,
DateEntreeProfessionCroissant = 50,
DateEntreeProfessionDecroissant = 51,
ServiceCroissant = 52,
ServiceDecroissant = 53,
DateNaissanceCroissant = 54,
DateNaissanceDecroissant = 55,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TriListeSalariesEnum.ts